import Component from '../abstracts/Component';

export default class SaleRangeComponent extends Component {
  get SELECTORS() {
    return {
      saleRangeInputs: '.filter-sale-range-box input',
    };
  }

  constructor(compEl) {
    super(compEl);
  }

  resetInputs() {
    const saleRangeInputs = document.querySelectorAll(this.SELECTORS.saleRangeInputs);
    // let's cycle them
    if (saleRangeInputs != null) {
      saleRangeInputs.forEach( (input) => {
        // check if i selected i remove the selected
        if (input.checked) {
          input.checked = false;
        }
      });
    }
  }

  buildQuery() {
    // base vars
    const saleRangeInputs = document.querySelectorAll(this.SELECTORS.saleRangeInputs);
    let query = '';
    // let's cycle them
    if (saleRangeInputs != null) {
      saleRangeInputs.forEach( (input) => {
        // facetName
        let facetCode = input.dataset.facetCode;
        // check if i selected it
        if (input.checked) {
          // build the query
          query += ":" + facetCode + ":" + input.dataset.filterValue;
        }
      });
    }
    console.log(query);
    //
    return query;
  }

  render() {
    // nothing to render
  }


}
